import { Route, Redirect, RouteProps } from 'react-router-dom';
import { NotFoundPage } from '../components';
import { useAuth } from '../context';

export function AdminRoute({ children, ...rest }: RouteProps) {
    const { session } = useAuth();
    return (
        <Route
            {...rest}
            render={({ location }) =>
                (session.Role === 1 || session.Role === 0) &&
                session.ForceChangePassword === 0 ? (
                    children
                ) : session.Role === 1 || session.Role === 0 ? (
                    <Redirect
                        to={{
                            pathname: '/force-change-password',
                            state: { from: location }
                        }}
                    />
                ) : (
                    <Redirect
                        to={{
                            pathname: '/login',
                            state: { from: location }
                        }}
                    />
                )
            }
        />
    );
}

export function EmployeeRoute({ children, ...rest }: RouteProps) {
    const { session } = useAuth();
    return (
        <Route
            {...rest}
            render={({ location }) =>
                session.Role !== 2 ? (
                    <Redirect
                        to={{
                            pathname: '/login',
                            state: { from: location }
                        }}
                    />
                ) : session.ForceChangePassword === 1 ? (
                    <Redirect
                        to={{
                            pathname: '/force-change-password',
                            state: { from: location }
                        }}
                    />
                ) : (
                    children
                )
            }
        />
    );
}
export const NotFoundRoute: React.FC = () => <Route component={NotFoundPage} />;
